import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=1d18a02c&scoped=true"
import script from "./ServiceDetail.vue?vue&type=script&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=1d18a02c&prod&lang=stylus&scoped=true"
import style1 from "./ServiceDetail.vue?vue&type=style&index=1&id=1d18a02c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18a02c",
  null
  
)

export default component.exports